import { getIsLoggedInSelector, getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { oneFetchye } from 'fetchye-one-app';
import { loadMembershipDomain } from './loadMembershipDomain';
import { clients, placements } from '../constants/moduleConstants';
import { requiresMembershipDomain } from '../utils/membershipDomainUtils';
import { loadArticlesThunk } from '../oneData';
import { MembershipValue } from '../constants/membershipDomainConstants';
import { constructOneDataBody } from '../utils/oneDataBody';

export const loadArticles = ({
  clientId, placementId,
}: {
  clientId: string,
  placementId: string
}) => async (dispatch: Function, getState: Function) => {
  if (
    !clientId
    || !placementId
    || !clients.has(clientId)
    || !placements.has(placementId)
  ) {
    return [];
  }

  const state = getState();
  const isLoggedIn = getIsLoggedInSelector(state);

  let membershipData: { data: { membership: MembershipValue[] } } | undefined;
  if (isLoggedIn && requiresMembershipDomain(placementId)) {
    const { data: membershipAPIData } = await dispatch(loadMembershipDomain);
    await dispatch(oneFetchye('https://qicm.aexp-static.com/Internet/travel/common/en-gb/legal.json'));
    membershipData = membershipAPIData;
  }

  const locale = getActiveLocaleSelector(state);
  const oneDataBody: Record<string, unknown> = constructOneDataBody({
    locale, clientId, placementId,
  }, membershipData);

  await dispatch(oneFetchye('https://qicm.aexp-static.com/Internet/travel/common/en-gb/support.json'));
  await dispatch(loadArticlesThunk({
    body: JSON.stringify(oneDataBody),
  }));
};
